/**
 * App.tsx - React Router setup with all routes.
 * Generated by WebsiteGenerator.
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeaderCard from './components/cards/HeaderCard';
import FooterCard from './components/cards/FooterCard';
import HomePage from './pages/HomePage';
import OurMissionPage from './pages/OurMissionPage';
import OfferingsPage from './pages/OfferingsPage';
import ContactUsPage from './pages/ContactUsPage';
import './styles/theme.css';
import './styles/global.css';
import './styles/card.css';

const NAV_ITEMS = [
  { label: "Home", href: "/", cta: false },
  { label: "Our Mission", href: "/our-mission", cta: false },
  { label: "Offerings", href: "/offerings", cta: false },
  { label: "Contact Us", href: "/contact-us", cta: false }
];

const App: React.FC = () => {
  return (
    <Router>
      <div id="app-root" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <HeaderCard nav={NAV_ITEMS} logoSrc="/images/Green_Logo.png" logoPosition="right" />
        <main style={{ flex: 1 }}>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/our-mission" element={<OurMissionPage />} />
          <Route path="/offerings" element={<OfferingsPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="*" element={<div style={{ padding: '4rem 2rem', textAlign: 'center' }}><h1>404 - Page Not Found</h1><a href="/" className="btn btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>Go Home</a></div>} />
          </Routes>
        </main>
        <FooterCard />
      </div>
    </Router>
  );
};

export default App;
